module.exports = __webpack_public_path__ + "packs/media/images/pic04-7a47d97cd49c561d566765a0c23b6ffb.jpg";